module.exports = __webpack_public_path__ + "static/media/pastor_bio.55699d0a.png";